export const getEnabledSettingsForTracking = notificationConfigs => {
  const {
    ['ENROLLMENT_DIGEST']: {
      isEnabled: isEnrollmentDigestEnabled
    },
    ['ISSUE_NOTIFICATION']: {
      isEnabled: isIssueNotificationEnabled
    },
    ['AI_BASED_ENROLLMENT_DIGEST']: {
      isEnabled: isAIBasedEnrollmentDigestEnabled
    }
  } = notificationConfigs;
  const enabledNotifications = [];
  if (isEnrollmentDigestEnabled) {
    enabledNotifications.push('ENROLLMENT_DIGEST');
  }
  if (isIssueNotificationEnabled) {
    enabledNotifications.push('ISSUE_NOTIFICATION');
  }
  if (isAIBasedEnrollmentDigestEnabled) {
    enabledNotifications.push('AI_BASED_ENROLLMENT_DIGEST');
  }
  return enabledNotifications;
};